import React from 'react'

import DynamicSchedulingCard from 'layouts/DynamicSchedulingCard'

import arrowSrc from './arrow.svg'

import './style.css'

const SchedulingCardPreview = () => {
  return (
    <div className="scheduling-card-preview">
      <div className="scheduling-card-preview-message">
        <p>
          This is what it looks like when a teammate books a meeting for you!
        </p>
        <img className="arrow-change" src={arrowSrc} alt="" />
      </div>
      <div className="scheduling-card-preview-container">
        <DynamicSchedulingCard
          className="scheduling-card-preview-example"
          showEmptyValues={true}
        />
      </div>
    </div>
  )
}

export default SchedulingCardPreview
